"use client";

import { useMutation } from "@tanstack/react-query";
import type { CreateAssessmentFeedbackRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { createAssessmentFeedback } from "../api/createAssessmentFeedback";

export default function useCreateAssessmentFeedbackMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: CreateAssessmentFeedbackRequest) =>
      createAssessmentFeedback(accessToken, request),
  });
}
